/** Merge flow and pressure buckets by timestamp or label so lines stay aligned. */
export function mergeChartSeries(primary = [], secondary = []) {
  const byKey = new Map();

  const addPoints = points =>
    points.forEach(point => {
      const key = point.timestamp ?? point.name;
      if (key == null) {
        return;
      }
      byKey.set(key, { ...byKey.get(key), ...point });
    });

  addPoints(secondary);
  addPoints(primary);

  return Array.from(byKey.values()).sort(
    (a, b) => Number(a.timestamp ?? 0) - Number(b.timestamp ?? 0),
  );
}
